import React, { Component } from "react";

import { demos } from "../data";
import Toolbar from "./Toolbar";

export default class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      screen: '1200',
      currentDemo: true,
      demos: []
    }
  }

  getCurrentTheme = (demos) => {
    let urlHash = window.location.hash;
    let currentDemoIndex = 0;
    if (urlHash) {
      currentDemoIndex = demos.findIndex(demo => {
        return demo.link === urlHash;
      });
    }
    return demos[currentDemoIndex];
  }

  getNewCurrentTheme = (event) => {
    let urlNew = event.currentTarget.firstElementChild.hash;
    let currentNewIndex = 0;
    if (urlNew) {
      currentNewIndex = demos.findIndex(demo => {
        return demo.link === urlNew;
      });
    }
    this.setState({ currentDemo: demos[currentNewIndex] });

  }

  componentDidMount() {
    let currentDemo = this.getCurrentTheme(demos);
    this.setState({ demos: demos, currentDemo: currentDemo });
  }

  handleScreen = (event) => {
    event = event.target.className;

    switch (event) {
      case "tablet":
        if (event === "tablet") {
          this.setState({
            screen: '1024',
            className: "tablet"
          });
        }
        break;

      case "vertical-tablet":
        if (event === "vertical-tablet") {
          this.setState({
            screen: '992',
            className: "vertical-tablet"
          });
        }
        break;

      case "mobile":
        if (event === "mobile") {
          this.setState({
            screen: '767',
            className: "mobile"
          });
        }
        break;

      case "vertical-mobile":
        if (event === "vertical-mobile") {
          this.setState({
            screen: '480',
            className: "vertical-mobile"
          });
        }
        break;

      default:
        this.setState({
          screen: '1900',
          className: "desktop"
        });
    }
  }

  render() {

    return (
      <div className={this.state.className} >
        <Toolbar
          {...this.state}
          handleScreen={this.handleScreen}
          getNewCurrentTheme={this.getNewCurrentTheme}
        />
        <WebView
          handleScreen={this.handleScreen}
          currentdemo={this.state.currentDemo}
        />
      </div >
    );
  }
}

const WebView = (props) => {
  let currentPage = props.currentdemo.domain;
  let titlePage = props.currentdemo.title;

  return (
    <div className="web-view">
      <iframe title={titlePage} src={currentPage} frameBorder="0" name="demo" width="100%" height="100%" />
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/App.js